import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ─── PWA service worker ──────────────────────────────────────────────────
// Registro silencioso: sem prompt de atualização. Quando um SW novo é
// detectado (installing/waiting), mandamos SKIP_WAITING pra ele assumir na
// hora — o sw.js já faz skipWaiting() no install + clients.claim() no
// activate, então a troca acontece em background sem recarregar a página.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        const promote = (worker) => {
          if (worker) worker.postMessage({ type: "SKIP_WAITING" });
        };
        // Já tem um esperando de uma visita anterior.
        promote(registration.waiting);
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed") promote(installing);
          });
        });
      })
      .catch(() => {
        /* SW é progressive enhancement — falha não quebra o app */
      });
  });
}
